<!-- The layout fills the content box exactly, so the crime-type list absorbs the
     overflow and the modal itself has nothing to scroll. Ionic's own scrolling is
     left enabled as a fallback: on a viewport too short for the list's min-height
     it is what keeps the Confirm button reachable rather than clipped. -->
<ion-content class="ion-content__modal complete-details" [class.is-saved]="saved">

    <div class="complete-details__layout">

        <!-- Green card: icon, title + subtitle, with the close X in the corner.
             Once saved it takes over the whole modal as the confirmation. -->
        <div class="complete-details__hero">
            <div class="complete-details__close pointer" (click)="dismiss()">
                <ion-icon name="close"></ion-icon>
            </div>

            <div class="complete-details__bell">
                <img alt="" src="assets/icons/require_account_details_icon.png" />
            </div>

            <div class="complete-details__title">{{ heroTitle }}</div>

            <div class="complete-details__subtitle">
                {{ lang.data['account.complete_details.modal_subtitle'] || 'To support you well, we need to know a little more about you.' }}
            </div>
        </div>

        <form [formGroup]="detailsForm" class="complete-details__form" *ngIf="detailsForm && !saved">

            <div class="field-wrapper" *ngIf="showRegistrationType">
                <label class="form-label required">
                    {{ lang.data['register.registration_type.label'] || 'Which option describes you?' }}
                </label>

                <ion-radio-group formControlName="registration_type">
                    <ion-item lines="none" class="support-target__option">
                        <ion-radio class="ion-text-wrap" value="victim" mode="md"
                                   labelPlacement="start" justify="space-between">
                            {{ lang.data['register.registration_type.victim'] || 'I would like support for myself' }}
                        </ion-radio>
                    </ion-item>
                    <ion-item lines="none" class="support-target__option">
                        <ion-radio class="ion-text-wrap" value="supporter" mode="md"
                                   labelPlacement="start" justify="space-between">
                            {{ lang.data['register.registration_type.supporter'] || 'I would like information to support somebody else' }}
                        </ion-radio>
                    </ion-item>
                </ion-radio-group>
            </div>

            <!-- Takes the leftover height: the list scrolls, the modal does not. -->
            <div class="field-wrapper complete-details__crime-types" *ngIf="showCrimeTypes">
                <label class="form-label required">
                    {{ lang.data['crime_types.title'] || 'Which areas can we support you in?' }}
                </label>

                <app-crime-type-picker
                    formControlName="crime_type_ids"
                    variant="checkboxes"
                    subtitlePosition="below"
                    [showTitle]="false"
                    [scrollable]="true"
                    [preselectDomesticAbuse]="preselectDomesticAbuse"
                    [invalid]="f['crime_type_ids'].invalid && f['crime_type_ids'].touched">
                </app-crime-type-picker>
            </div>

            <ion-button class="complete-details__save" expand="block" type="button"
                        [disabled]="submitting" (click)="save()">
                {{ lang.data['account.complete_details.save'] || 'Confirm selection' }}
            </ion-button>
        </form>

    </div>

</ion-content>
